/* Elemence Cart — AJAX qty + remove via Shopify cart endpoints.
   Each line has data-line-key. Changes hit /cart/change.js and re-render
   the whole section markup via /?section_id=<id>. */
(function () {
  const sel = '.elemence-cart';
  // Locale-aware root ('/' or '/de/') so Shopify's error messages and the
  // re-rendered section come back in the storefront language.
  const localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function changeLine(key, qty) {
    const res = await fetch(localeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    // Shopify returns 422 with a JSON body { status, message, description }
    // when it can't fulfill the request (e.g. stock limit, sold out). Surface
    // the message so the user sees WHY their change didn't apply.
    if (!res.ok) {
      let detail = '';
      try {
        const data = await res.json();
        detail = data.description || data.message || '';
        console.warn('[cart] change.js error:', res.status, data);
      } catch (e) { /* ignore */ }
      const err = new Error('change failed: ' + res.status + (detail ? ' — ' + detail : ''));
      err.detail = detail;
      err.status = res.status;
      throw err;
    }
    return res.json();
  }

  function showLineError(item, msg) {
    if (!item || !msg) return;
    let bar = item.querySelector('.elemence-cart__item-error');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'elemence-cart__item-error';
      bar.setAttribute('role', 'alert');
      item.appendChild(bar);
    }
    bar.textContent = msg;
    clearTimeout(bar._t);
    bar._t = setTimeout(() => { bar.remove(); }, 4500);
  }

  async function rerender(root) {
    const m = (root.id || '').match(/^shopify-section-(.+)$/);
    const sectionId = m ? m[1] : null;
    if (!sectionId) { location.reload(); return; }
    try {
      const res = await fetch(localeRoot + '?section_id=' + encodeURIComponent(sectionId), { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const fresh = wrap.querySelector(sel);
      if (fresh && root.parentNode) {
        root.parentNode.replaceChild(fresh, root);
        attach(fresh);
      } else {
        location.reload();
      }
    } catch (e) {
      location.reload();
    }
  }

  function attach(root) {
    if (!root || root.dataset.cartInit === '1') return;
    root.dataset.cartInit = '1';

    root.querySelectorAll('.elemence-cart__item').forEach((item) => {
      const key = item.getAttribute('data-line-key');
      if (!key) return;
      const incBtn = item.querySelector('[data-action="inc"]');
      const decBtn = item.querySelector('[data-action="dec"]');
      const remBtn = item.querySelector('[data-action="remove"]');
      const input  = item.querySelector('input[name="quantity"]');

      const setQty = async (q) => {
        if (q < 0) q = 0;
        const previous = parseInt(input ? input.value : '0', 10) || 0;
        item.classList.add('elemence-cart__item--loading');
        try {
          await changeLine(key, q);
          await rerender(root);
        } catch (e) {
          item.classList.remove('elemence-cart__item--loading');
          // Roll the input back so the visible qty matches actual cart state.
          if (input) input.value = String(previous);
          showLineError(item, e.detail || ((root.querySelector('.elemence-cart__container') || {}).dataset || {}).updateError || 'Could not update quantity.');
        }
      };

      if (incBtn) incBtn.addEventListener('click', () => setQty(parseInt(input.value || '0', 10) + 1));
      if (decBtn) decBtn.addEventListener('click', () => setQty(Math.max(0, parseInt(input.value || '0', 10) - 1)));
      if (remBtn) remBtn.addEventListener('click', () => setQty(0));
      if (input) {
        input.addEventListener('change', () => {
          const q = Math.max(0, parseInt(input.value || '0', 10));
          setQty(q);
        });
      }
    });
  }

  function init() {
    document.querySelectorAll(sel).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll(sel).forEach(attach);
    }
  });
})();
